export const ID_COLUMN_WIDTH = 0
export const SUPPLY_COLUMN_WIDTH = 100
export const SUPPLY_NUMBER_COLUMN_WIDTH = 100
export const ADDRESS_COLUMN_WIDTH = 200
export const QUANTITY_COLUMN_WIDTH = 50
export const SUPPLY_ACTIVE_COLUMN_WIDTH = 50
export const ENABLE_COLUMN_WIDTH = 50
